<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> SOLADO </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-toolbar-title v-if="sole.id"
          >{{ sole.id }} - {{ sole.name.toUpperCase() }}</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn outlined color="grey darken-3" @click="goToBackList()">
          <v-icon left>mdi-chevron-left</v-icon> Voltar
        </v-btn>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container fluid>
          <v-row>
            <v-col cols="12" xs="12" md="4">
              <v-text-field
                v-model="sole.name"
                class="text-field-uppercase"
                label="Nome"
                dense
                outlined
                required
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="8"> </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn color="blue darken-3" dark class="mt-5" @click="validate">
                <v-icon left>mdi-send</v-icon> Salvar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
  </div>
</template>

<script>
import { URL } from "@/api/config";
export default {
  components: {},
  data: () => ({
    loading: false,
    sole: {
      id: "",
      name: "",
    },
    valid: true,
    lazy: false,
    rules: {
      required: (value) => !!value || "Campo Obrigatorio",
    },
  }),
  computed: {},
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      if (this.$route.params.id) {
        this.getSole(this.$route.params.id);
      }
    },
    async getSole(id) {
      // this.showLoading();
      this.loading = true;
      try {
        let response = await fetch(`${URL}sole/${id}`);
        this.sole = await response.json();
      } catch (error) {
        this.sole = {};
        console.log(error);
        //this.showAlert({ message: error.message, type: "error" });
      } finally {
        this.loading = false;
        // this.hideLoading();
      }
    },
    goToBackList() {
      this.$router.push({ name: "Sole" });
    },
    validate() {
      if (this.$refs.form.validate()) {
        let data = {};
        data.name = this.sole.name.toUpperCase();
        if (this.sole.id === "") {
          this.post(data);
        } else {
          this.update(this.sole.id, data);
        }
      }
    },
    async post(data) {
      // this.showLoading();
      this.loading = true;
      let myHeaders = new Headers({
        "Content-Type": "application/json",
      });
      try {
        let res = await fetch(`${URL}sole`, {
          headers: myHeaders,
          method: "POST",
          body: JSON.stringify(data),
        });
        if (res) {
          // this.showAlert({
          //   message: "Tipo de Fornecedor salvo com sucesso",
          //   type: "success",
          // });
          this.goToBackList();
        }
      } catch (error) {
        console.log(error);
        // this.showAlert({ message: error.message, type: "error" });
      } finally {
        this.loading = false;
        // this.hideLoading();
      }
    },
    async update(id, data) {
      this.loading = true;
      let myHeaders = new Headers({
        "Content-Type": "application/json",
      });
      try {
        let res = await fetch(`${URL}sole/${id}`, {
          headers: myHeaders,
          method: "PUT",
          body: JSON.stringify(data),
        });
        if (res) {
          // this.showAlert({
          //   message: "Tipo de Fornecedor atualizado com sucesso",
          //   type: "success",
          // });
          this.goToBackList();
        }
      } catch (error) {
        console.log(error);
        // this.showAlert({ message: error.message, type: "error" });
      } finally {
        this.loading = false;
        // this.hideLoading();
      }
    },
    getLabelStatus(status) {
      return status == 1 ? "Ativo" : "Desativado";
    },
  },
};
</script>
<style>
.text-field-uppercase input {
  text-transform: uppercase;
}
</style>
